import React from 'react';
import PropTypes from 'prop-types';

import { Background as BackgroundElem, BackgroundInner as BackgroundInnerElem } from './Hero.styles';

const Hero = ({ hero, video, extraClassNames, heroHeight }) => {
  return (
    <BackgroundElem className={`relative h-screen-90 w-full ${extraClassNames}`} heroHeight={heroHeight}>
      <BackgroundInnerElem
        xs={hero.xs}
        sm={hero.sm}
        md={hero.md}
        xl={hero.xl}
        aria-label={hero.title}
        className="bg-center bg-no-repeat bg-cover h-full w-inherit flex items-end"
      >
        {video && (
          <video
            className="object-cover w-full h-full absolute"
            src={video.url}
            type="video/mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          />
        )}
      </BackgroundInnerElem>
    </BackgroundElem>
  );
};

Hero.propTypes = {
  hero: PropTypes.shape({
    title: PropTypes.string,
    xs: PropTypes.shape({
      url: PropTypes.string,
    }),
    sm: PropTypes.shape({
      url: PropTypes.string,
    }),
    md: PropTypes.shape({
      url: PropTypes.string,
    }),
    xl: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  video: PropTypes.shape({
    url: PropTypes.string,
  }),
  extraClassNames: PropTypes.string,
  heroHeight: PropTypes.shape({}),
};

Hero.defaultProps = {
  hero: {
    title: '',
    xs: {
      url: '/assets/hero-background-xs.jpg',
    },
    sm: {
      url: '/assets/hero-background-sm.jpg',
    },
    md: {
      url: '/assets/hero-background-md.jpg',
    },
    xl: {
      url: '/assets/hero-background-xl.jpg',
    },
  },
  video: null,
  extraClassNames: '',
  heroHeight: null,
};

export default Hero;
